import { features, logger } from '@/lib';
import { appStore } from '@/store';

export const logFptiForHiddenButtonSubmit = (): void => {
  const { value } = appStore.getState().form.onboardOption;
  logger.fpti('POMA_SUBMIT_VIA_ENTER_KEYPRESS', {
    state_name: 'billing',
    transition_name: 'process_poma_form_submit_via_enter_key',
    user_opts_signup: value === 'signup' ? 'Y' : 'N',
  });
};

export const logFptiForLoginButtonClick = (): void => {
  logger.fpti('existing_account_prompt_login_button_clicked', {
    buyer_type: 'existing_user',
    event_name: 'xo_guest_existing_account_prompt_login_button_clicked',
    forced_signup_offered: features.isActive('isForcedSignUp') ? 1 : 0,
    state_name: 'existing_account_interstitial',
    transition_name: 'process_login_button_clicked',
  });
};
